import { useCallback, useEffect, useRef, useState } from "react";

const STORAGE_PREFIX = "bandjoe_search:";

function storageKey() {
  if (typeof window === "undefined") return null;
  return `${STORAGE_PREFIX}${window.location.pathname}`;
}

function readStoredSearch() {
  const key = storageKey();
  if (!key) return "";

  try {
    return window.sessionStorage.getItem(key) || "";
  } catch {
    return "";
  }
}

export default function useDebouncedSearch(delay = 1000) {
  const [inputValue, setInputValue] = useState(readStoredSearch);
  const [searchValue, setSearchValue] = useState(readStoredSearch);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const key = storageKey();
    if (key) {
      try {
        if (inputValue) window.sessionStorage.setItem(key, inputValue);
        else window.sessionStorage.removeItem(key);
      } catch {
        // Search still works when storage is unavailable (for example, in privacy mode).
      }
    }

    timeoutRef.current = setTimeout(() => setSearchValue(inputValue), delay);
    return () => clearTimeout(timeoutRef.current);
  }, [delay, inputValue]);

  const submitSearch = useCallback((event) => {
    event?.preventDefault();
    clearTimeout(timeoutRef.current);
    setSearchValue(inputValue);
  }, [inputValue]);

  return { inputValue, setInputValue, searchValue, submitSearch };
}
